import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBar/index";
// import './Uploaded-Details/uploaded-details.scss';
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  vendorDeleteCheckpointLocationCommnets,
  vendorGetCheckpointInfoBySpecificLocation,
  vendorGetCheckpointLocationHistory,
  vendorGetCheckpointLocationHistoryExpiryDate,
} from "@services/checkpoint.service";
import qs from "query-string";
import moment from "moment";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import Header from "@components/common/Header";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import CommentsModal from "../Modal/comments";
import { useParams } from "react-router-dom";
import DeleteModal from "../../../../_common/deleteModal";
import { toast } from "react-toastify";
import { formatText } from "../../../../_common/text-helper";
import InputField from "../../../../_common/InputRuleFeild";
import { handleDownloadOnClick } from "../../../../_common/downloadfile";
import { handleS3FileDownloadOnClick } from "../../../../_common/s3-downloadfile";
import { monthsString } from "@_common/month";
import { QueryRequestHelper } from "@_common/query-request-helper";
interface ICheckPointDetailsProps {}

export const CheckPointHistoryDetails: React.FunctionComponent<
  ICheckPointDetailsProps
> = (props) => {
  let navigate = useNavigate();
  let mainParams = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const [historyExpiryDate, setHistoryExpiryDate] = useState<any>(null);
  const [historyComments, setHistoryComments] = useState("");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Runs when the component mounts

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0) {
      getData();
      setDate(new Date());
    }
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0) {
      getData();
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : 10,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      update_status: params.update_status,
      location_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      checkpoint_id: mainParams.checkpoint_id,
      is_redirect: true,
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorGetCheckpointLocationHistory(queryRequest);
      if (resp) {
        setIsLoading(false);
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      let resp = await vendorGetCheckpointLocationHistoryExpiryDate(editID, {
        expiry_date: historyExpiryDate,
        commentsInfo: {
          comments: historyComments,
          type: "SUBMISSION_COMMENT",
        },
      });
      if (resp) {
        setSubmitLoading(false);
        setHistoryComments("");
        setHistoryExpiryDate(null);
        handleModal1Cancel();
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: page_no,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      limit: limit,
      page_no: 1,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    let payload: any = {
      search_text: e.target.value,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const [editID, setEditID] = useState("");
  const [isOpen1, setIsOpen1] = useState(false);
  const handleModal1 = (obj: object) => {
    setEditID(getValue(obj, `id`, ""));
    setHistoryExpiryDate(getValue(obj, `expiry_date`, ""));
    setIsOpen1(!isOpen1);
  };
  const handleModal1Cancel = () => {
    setIsOpen1(!isOpen1);
    setEditID("");
  };
  const [vendorInfo, setVendorInfo] = useState({});
  const handleModalComment = (obj: object) => {
    setVendorInfo(obj);
    handleModal();
  };
  const handleModalCommentCancel = () => {
    setVendorInfo({});
    handleModal();
  };

  const handleUpdateStatus = (update_status: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.update_status = update_status;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                             */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    let payload: any = {
      date: dates,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return (
    <>
      <Header />
      {/* <NotificationBar isFilterVisisbile={true} /> */}
      <div className="checkpoint-wrapper position-relative">
        <div className="uploaded-details-wrapper uploaded-details-wrapper--checkpoint">
          <div className="uploaded-details-wrapper__header-checkpoint d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center py-4">
              <NavLink
                to={`/checkpoint/details/${mainParams.id}/${mainParams.date}/${
                  mainParams.code
                }/${getValue(mainParams, `listenable`, "").trim()}/${getValue(
                  mainParams,
                  `audit_status`,
                  ""
                )}/${getValue(mainParams, `score`, "")}`}
              >
                <img src="/images/back-link.svg" className="img-fluid " />
              </NavLink>
              <p className="uploaded-details-wrapper__date px-2">
                History
                {/* -
								{moment(new Date(mainParams.date)).format('MMM, YYYY')} */}
              </p>
            </div>
          </div>
          <div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint  d-flex">
            <div className="uploaded-details-wrapper-form-group form-group">
              {/* <label
								className="m-0 position-relative"
								htmlFor="header-checkbox"
							>
								<input
									type="checkbox"
									className="default-checkbox"
									id="header-checkbox"
								/>
								<div className="custom-checkbox">
									<img
										src="/images/uploaded-details/tick.svg"
										className="img-fluid uploaded-tick"
									/>
								</div>
							</label> */}
            </div>
            <div className="uploaded-details-wrapper__rules-wrapper">
              <h6 className="uploaded-details-wrapper__header-title">Rule</h6>
              <p className="uploaded-details-wrapper__header-text">
                Compliance Activity
              </p>
            </div>
            <div className="uploaded-details-wrapper__rules-wrapper">
              <h6 className="uploaded-details-wrapper__header-title">
                Month for
              </h6>
              <p className="uploaded-details-wrapper__header-text">
                Location Name
              </p>
            </div>
            <div className="uploaded-details-wrapper__status-wrapper">
              <h6 className="uploaded-details-wrapper__header-title">
                Upload Status
              </h6>
              <p className="uploaded-details-wrapper__header-text">
                Audit Status
              </p>
            </div>
            <div className="uploaded-details-wrapper__status-wrapper">
              <h6 className="uploaded-details-wrapper__header-title">
                Audit on
              </h6>
              <p className="uploaded-details-wrapper__header-text">
                Expiry Date
              </p>
            </div>
            <div className="uploaded-details-wrapper__icons-wrapper">
              <h6 className="uploaded-details-wrapper__header-title"></h6>
            </div>
            {/* <div className="uploaded-details-wrapper__frequency-wrapper">
							<h6 className="uploaded-details-wrapper__header-title">
								Actions
							</h6>
						</div> */}
          </div>

          {isLoading ? (
            <Loader />
          ) : getValue(locations, `length`, 0) > 0 ? (
            locations.map((uploadDetailsObj: object, index: number) => {
              return (
                <div className="uploaded-details-wrapper__body-checkpoint-border uploaded-details-wrapper__header-checkpoint">
                  <div
                    className="uploaded-details-wrapper__body  uploaded-details-wrapper__body--checkpoint  d-flex"
                    key={`details-${index}`}
                  >
                    {/* <div></div> */}
                    <div className="uploaded-details-wrapper-form-group form-group">
                      {/* <label
												className="m-0 position-relative"
												htmlFor={`details-${index}`}
											>
												<input
													type="checkbox"
													className="default-checkbox"
													id={`details-${index}`}
													// checked={selectedIndex.includes(
													// 	getValue(uploadDetailsObj, `id`, "")
													// )}
													// onChange={() =>
													// 	handleChangeCheckbox(
													// 		getValue(uploadDetailsObj, `id`, "")
													// 	)
													// }
												/>
												<div className="custom-checkbox">
													<img
														src="/images/uploaded-details/tick.svg"
														className="img-fluid uploaded-tick"
													/>
												</div>
											</label> */}
                    </div>
                    <label
                      className="uploaded-details-wrapper__rules-wrapper uploaded-details-wrapper__rules-wrapper--history cursor-pointer"
                      htmlFor={`details-${index}`}
                    >
                      <h6 className="uploaded-details-wrapper__body-title">
                        {getValue(
                          uploadDetailsObj,
                          `checkpoint.legislation_rule.rule_name`,
                          ""
                        )}
                      </h6>
                      <p className="uploaded-details-wrapper__body-text">
                        {getValue(
                          uploadDetailsObj,
                          `checkpoint.compliance_activity`,
                          ""
                        )}
                      </p>
                    </label>

                    <div className="uploaded-details-wrapper__location-wrapper">
                      <h6 className="uploaded-details-wrapper__body-title">
                        {
                          monthsString[
                            parseInt(getValue(uploadDetailsObj, `month`, ""))
                          ]
                        }
                        {", "}
                        {getValue(uploadDetailsObj, `year`, "")}
                      </h6>
                      <p className="uploaded-details-wrapper__body-text">
                        {getValue(
                          uploadDetailsObj,
                          `location.location_name`,
                          ""
                        )}
                      </p>
                    </div>

                    <div className="uploaded-details-wrapper__status-wrapper">
                      <h6 className="uploaded-details-wrapper__body-title uploaded-details-wrapper__body-title--green">
                        {formatText(
                          getValue(uploadDetailsObj, `upload_status`, "")
                        )}
                      </h6>
                      <p className="uploaded-details-wrapper__body-text">
                        {formatText(
                          getValue(uploadDetailsObj, `audit_status`, "")
                        )}
                      </p>
                    </div>
                    <div className="uploaded-details-wrapper__status-wrapper">
                      <h6 className="uploaded-details-wrapper__body-title uploaded-details-wrapper__body-title--green">
                        {getValue(uploadDetailsObj, `audited_at`, "")
                          ? moment(
                              getValue(uploadDetailsObj, `audited_at`, "")
                            ).format("DD MMM YYYY")
                          : "-"}
                      </h6>
                      <p className="uploaded-details-wrapper__body-text">
                        {getValue(uploadDetailsObj, `expiry_date`, "")
                          ? moment(
                              getValue(uploadDetailsObj, `expiry_date`, "")
                            ).format("DD MMM YYYY")
                          : "-"}
                      </p>
                      {getValue(uploadDetailsObj, `expiry_date`, "") && (
                        <img
                          src="/images/list-management/country/edit-icon.svg"
                          className="img-fluid cursor-pointer"
                          onClick={() => handleModal1(uploadDetailsObj)}
                        />
                      )}
                    </div>
                    <div className="uploaded-details-wrapper__icons-wrapper">
                      {getValue(uploadDetailsObj, `upload_status`, "") ===
                      "UPLOADED" ? (
                        <img
                          src="/images/audit-review/check-green.svg"
                          className="img-fluid cursor-pointer"
                          height={36}
                          width={36}
                        />
                      ) : (
                        <img
                          src="/images/audit-review/check-gray.svg"
                          className="img-fluid cursor-pointer"
                          height={36}
                          width={36}
                        />
                      )}
                      <img
                        src="/images/audit-review/mail.svg"
                        className="img-fluid cursor-pointer"
                        height={36}
                        width={36}
                        onClick={() => handleModalComment(uploadDetailsObj)}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap mx-4">
                    {getValue(uploadDetailsObj, `documents.length`, 0) > 0 &&
                      getValue(uploadDetailsObj, `documents`, []).map(
                        (items: object, ind: number) => {
                          return (
                            <div key={ind}>
                              {getValue(items, `extension`, "") === ".pdf"
                                ? getValue(items, `url`, "") && (
                                    <div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
                                      <img
                                        src="/images/uploaded-details/pdf.svg"
                                        className="img-fluid cursor-pointer"
                                      />
                                      <p
                                        className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                                        onClick={() =>
                                          handleS3FileDownloadOnClick(
                                            getValue(items, `key`, ""),
                                            getValue(items, `name`, "")
                                          )
                                        }
                                      >
                                        {getValue(items, `name`, "")}
                                      </p>
                                      <img
                                        // onClick={() =>
                                        // 	handleDeleteFile(
                                        // 		getValue(uploadDetailsObj, `id`, ""),
                                        // 		getValue(items, `id`, "")
                                        // 	)
                                        // }
                                        src="/images/uploaded-details/close-grey.svg"
                                        className="img-fluid cursor-pointer"
                                      />
                                    </div>
                                  )
                                : getValue(items, `url`, "") && (
                                    <div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
                                      <img
                                        // onClick={() =>
                                        // 	handleDeleteFile(
                                        // 		getValue(uploadDetailsObj, `id`, ""),
                                        // 		getValue(items, `id`, "")
                                        // 	)
                                        // }
                                        src="/images/uploaded-details/word.svg"
                                        className="img-fluid cursor-pointer"
                                      />
                                      <p
                                        className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                                        onClick={() =>
                                          // handleS3FileDownloadOnClick(
                                          // 	getValue(items, `key`, ''),
                                          // 	getValue(items, `name`, '')
                                          // )
                                          handleDownloadOnClick(
                                            getValue(items, `url`, ""),
                                            getValue(items, `name`, "")
                                          )
                                        }
                                      >
                                        {getValue(items, `name`, "")}
                                      </p>
                                      {/* <img
																		src="/images/uploaded-details/close-grey.svg"
																		className="img-fluid cursor-pointer"
																	/> */}
                                    </div>
                                  )}
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              );
            })
          ) : (
            <>
              {Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
            </>
          )}
          <div className="pagination-wrapper mb-3">
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
              />
            ) : (
              ""
            )}
          </div>
          {isOpen && (
            <CommentsModal
              {...props}
              isOpen={isOpen}
              handleModal={handleModalCommentCancel}
              vendorInfo={vendorInfo}
              edit={false}
            />
          )}
          {isOpen1 && (
            <Modal isOpen={isOpen1}>
              <div>
                <h3>Change Expiry Date</h3>
                <InputField
                  inputType="DATETYPE"
                  value={new Date(historyExpiryDate)}
                  className="form-control"
                  onChange={(e: any) =>
                    setHistoryExpiryDate(moment(e).format("YYYY-MM-DD"))
                  }
                  minDate={new Date()}
                />
                <p style={{ color: "#1A73E8" }}>
                  Note: Any change in date will lead to re-auditing this
                  checkpoint
                </p>
                <br />
                <h3>Reason for the change</h3>
                <InputField
                  inputType="TEXTAREA"
                  rows={8}
                  placeholder="Enter Comments"
                  value={historyComments}
                  onChange={(e: any) => setHistoryComments(e.target.value)}
                />
                <div className="d-flex justify-content-end m-3">
                  <button
                    className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                    onClick={() => handleModal1Cancel()}
                  >
                    Cancel
                  </button>
                  {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </Modal>
          )}
        </div>
        {/* <div className="w-100">
					{locations.length > 0 && (
						<img src="/images/footer.svg" className="img-fluid" />
					)}
				</div> */}
      </div>
    </>
  );
};
